import { Component } from 'react'
import PropTypes from 'prop-types'
import { SelectBox } from "components/uikit-adapter/index"
import Fetch from 'utils/fetch'
import { Row, Col } from "react-flexbox-grid";

import Dialog from 'material-ui/Dialog'
import SnackBar from 'material-ui/Snackbar'

import './labeled-family-edit.css'

import {
  searchWallets,
  searchLabeledFamilyById
} from "./labeled-family-form.service";

import intl from 'react-intl-universal'
import { formatErrorMessage } from 'utils/handle-error';
import { Switcher } from 'components/toggle';
import { hideSomeSettingsLabeledFamily, usesOORRelevance, usesTmsIntegration } from 'utils/validations-general-settings';
import Input from 'components/input/index.tsx';
import Button from 'components/button';

class LabeledFamilyForm extends Component {
  constructor() {
    super()
    this._isMounted = false;
    this.state = {
      labeledFamily: {},
      families: [],
      wallets: [],
      selectedWallet: null,
      selectedFamily: null,
      selectedSaneamentoVolumesPendentes: true,
      selectedPilotoAutomatico: false,
      selectedAcionamentoTransporteCIF: false,
      selectedOORRelevance: true,
      isFetching: false,
      showMsg: false,
      textMsg: ''
    }
  }

  componentDidMount = () => {
    this._isMounted = true;
    const editMode = this.props.editMode

    if (editMode) {
      this.searchLabeledFamilyById()
    }

    this.searchWallets()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  searchWallets = async () => {
    try {
      const data = await searchWallets();
      this.proccessWalletData(data);
    } catch (e) {
      console.error(e)
    }
  }

  proccessErro = (exception) => {
    this.props.handleFeedback(formatErrorMessage(exception))
  }

  searchFamilies = (value) => {
    Fetch.get(`/families:by-material-group?MaterialGroupId=${value}`)
      .then((response) => this.proccessFamilyData(response.data))
      .catch((e) => this.proccessErro(e))
  }

  searchLabeledFamilyById = async () => {
    const idFamily = this.props.idEdit
    try {
      const data = await searchLabeledFamilyById(idFamily);
      this.proccessData(data);
    } catch (e) {
      this.proccessErro(e)
    }
  }

  proccessData = (data) => {
    this.setState({
      labeledFamily: data,
      selectedFamily: data.FamilyId,
      selectedWallet: data.MaterialGroupId,
      selectedPilotoAutomatico: data.AutomaticPilot,
      selectedAcionamentoTransporteCIF: data.TransportDriveCIF,
      selectedSaneamentoVolumesPendentes: data.SanitationPendingVolumes,
      selectedOORRelevance: data.RelevancyOOR
    })

    this.searchFamilies(data.MaterialGroupId)
  }

  proccessWalletData = (data) => {
    if (this._isMounted) {
      this.setState({ wallets: data })
    }
  }

  proccessFamilyData = (data) => {
    if (this._isMounted) {
      this.setState({ families: data })
    }
  }

  changeValue = (event) => {
    const prop = event.target.name
    const value = event.target.value

    this.setState(prevState => ({
      labeledFamily: {
        ...prevState.labeledFamily,
        [prop]: value
      }
    }))
  }

  finalizeProccessEstoqueError = () => {
    if (this._isMounted) {
      this.setState({
        showMsg: false,
        textMsg: ''
      })
    }

  }

  verifyIsGarrafa = (idCarteira) => {
    const carteira = this.state.wallets.find(x => x.Id === idCarteira);
    return carteira ? carteira.IsBottle : false;
  }

  save = () => {
    const editMode = this.props.editMode;
    const familyId = this.props.idEdit;
    let model = {};

    if (editMode) {
      model = {
        Id: familyId,
        MilheiroHectoliters: this.state.labeledFamily.MilheiroHectoliters,
        DeliveryBreak: this.state.labeledFamily.DeliveryBreak,
        Description: this.state.labeledFamily.Description,
        MaterialGroupId: this.state.selectedWallet || 0,
        FamilyId: this.state.selectedFamily || 0,
        AutomaticPilot: this.state.selectedPilotoAutomatico,
        TransportDriveCIF: this.state.selectedAcionamentoTransporteCIF,
        RelevancyOOR: this.state.selectedOORRelevance,
        SanitationPendingVolumes: this.state.selectedSaneamentoVolumesPendentes
      }
    } else {
      model = {
        AutomaticPilot: this.state.selectedPilotoAutomatico,
        Description: this.state.labeledFamily.Description,
        FamilyId: this.state.selectedFamily || 0,
        MaterialGroupId: this.state.selectedWallet || 0,
        MilheiroHectoliters: this.state.labeledFamily.MilheiroHectoliters,
        RelevancyOOR: this.state.selectedOORRelevance,
        SanitationPendingVolumes: this.state.selectedSaneamentoVolumesPendentes,
        TransportDriveCIF: this.state.selectedAcionamentoTransporteCIF,
      }
    }

    const promisse = !editMode
      ? Fetch.post(`/labeled-families`, model)
      : Fetch.put(`/labeled-families/${familyId}`, model)

    promisse.then(this.props.handleRefresh)
      .then(() => this.props.handleFeedback(`${intl.get('feedbacks.register')} ${!editMode ? intl.get('feedbacks.saved') : intl.get('feedbacks.updated')} ${intl.get('feedbacks.withSuccess')}`))
      .catch((e) => this.proccessErro(e))
  }

  updateSelectValue = (prop, value) => {
    this.setState({
      [prop]: value
    }, () => {
      if (prop === 'selectedWallet') {
        this.searchFamilies(value)
      }
    })
  }

  render() {
    let {
      labeledFamily,
      families,
      wallets,
      selectedWallet,
      selectedFamily,
      selectedSaneamentoVolumesPendentes,
      selectedPilotoAutomatico,
      selectedAcionamentoTransporteCIF,
      selectedOORRelevance,
      showMsg,
      textMsg
    } = this.state

    let { open, editMode, handleClose, profileAdminOrMasterData } = this.props

    return (
      <div>
        <Dialog
          title={editMode ? intl.get('master-data.walletsAndFamilys.labeledFamily.actions.editLabeledFamily') : intl.get('master-data.walletsAndFamilys.labeledFamily.actions.newLabeledFamily')}
          contentStyle={{ width: '600px' }}
          open={open}
          autoScrollBodyContent
        >

          <div className='line-1-columns'>
            <SelectBox
              required
              label={intl.get('commons.wallet')}
              valueKey='Id'
              labelKey='Description'
              placeholder={intl.get('commons.wallet')}
              value={selectedWallet}
              options={wallets}
              onChange={value => this.updateSelectValue('selectedWallet', value.Id)}
              disabled={!profileAdminOrMasterData}
              searchable
              openOnFocus
            />
          </div>

          <div className='line-1-columns'>
            <SelectBox
              required
              label={intl.get('commons.family')}
              placeholder={intl.get('commons.family')}
              valueKey='Id'
              labelKey='Name'
              value={selectedFamily}
              options={families}
              onChange={value => this.updateSelectValue('selectedFamily', value.Id)}
              disabled={!profileAdminOrMasterData}
              searchable
              openOnFocus
            />
          </div>

          <div className='line-1-columns'>
            <Input
              required
              name='Description'
              label={intl.get('commons.description')}
              value={labeledFamily.Description}
              onChange={this.changeValue}
              disabled={!profileAdminOrMasterData}
            />
          </div>

          {this.verifyIsGarrafa(this.state.selectedWallet) && <div>
            <Input
              label={intl.get('commons.hectolitersThousand')}
              name='MilheiroHectoliters'
              htmlType="number"
              value={labeledFamily.MilheiroHectoliters}
              onChange={this.changeValue}
            />
          </div>
          }

          {(!hideSomeSettingsLabeledFamily()) &&
            <>
              <label className="label-style">{intl.get('master-data.menus.configuration')}</label>
              <div className="container">
                <Row>
                  <Col xs={5} style={{ marginTop: '5px' }}>
                    <Switcher
                      name="PilotoAutomatico"
                      label="Auto Pilot"
                      className="autoPilot"
                      value={selectedPilotoAutomatico}
                      onChange={val => this.updateSelectValue('selectedPilotoAutomatico', val.checked)}
                      thumbSwitchedStyle={{ backgroundColor: 'var(--color-action-default)' }}
                      trackSwitchedStyle={{ backgroundColor: 'var(--color-neutral-200)' }}
                      disabled={!profileAdminOrMasterData}
                    />
                  </Col>
                  <Col xs={7} style={{ marginTop: '5px' }}>
                    <Switcher
                      name="AcionamentoTransporteCIF"
                      label={intl.get('master-data.general-configuration.triggerTransportCif')}
                      className="acionamentoCIF"
                      value={selectedAcionamentoTransporteCIF}
                      onChange={val => this.updateSelectValue('selectedAcionamentoTransporteCIF', val.checked)}
                      thumbSwitchedStyle={{ backgroundColor: 'var(--color-action-default)' }}
                      trackSwitchedStyle={{ backgroundColor: 'var(--color-neutral-200)' }}
                      disabled={!profileAdminOrMasterData}
                    />
                  </Col>
                </Row>

                <Row>
                  {usesOORRelevance() &&
                    <Col xs={5} style={{ marginTop: '5px' }}>
                      <Switcher
                        name="RelevanciaOOR"
                        label={intl.get('master-data.general-configuration.relevanceOOR')}
                        value={selectedOORRelevance}
                        className="relevanciaOOR"
                        onChange={val => this.updateSelectValue('selectedOORRelevance', val.checked)}
                        thumbSwitchedStyle={{ backgroundColor: 'var(--color-action-default)' }}
                        trackSwitchedStyle={{ backgroundColor: 'var(--color-neutral-200)' }}
                        disabled={!profileAdminOrMasterData}
                      />
                    </Col>
                  }
                  <Col xs={7} style={{ marginTop: '5px' }}>
                    {usesTmsIntegration() &&
                      <Switcher
                        name="SaneamentoVolumesPendentes"
                        label={intl.get('master-data.general-configuration.cleanseBulkPending')}
                        value={selectedSaneamentoVolumesPendentes}
                        onChange={val => this.updateSelectValue('selectedSaneamentoVolumesPendentes', val.checked)}
                        thumbSwitchedStyle={{ backgroundColor: 'var(--color-action-default)' }}
                        trackSwitchedStyle={{ backgroundColor: 'var(--color-neutral-200)' }}
                        disabled={!profileAdminOrMasterData}
                      />
                    }
                  </Col>
                </Row>
              </div>
            </>
          }
          <div className='footer-dialog-buttons__edit-labeled-family'>
            <Button
              value={intl.get('geral.buttonsDefault.cancel')}
              onClick={handleClose}
              buttonType="default"
              className="buttons__edit-labeled-family"
            />
            {profileAdminOrMasterData &&
              <Button
                value={intl.get('geral.buttonsDefault.save')}
                buttonType="primary"
                className='buttons__edit-labeled-family btn__save'
                onClick={this.save}
              />
            }
          </div>
          <SnackBar
            message={textMsg}
            open={showMsg}
            autoHideDuration={3000}
            onRequestClose={this.finalizeProccessEstoqueError}
            style={{ width: '100%', textAlign: 'center', display: 'block' }}
          />
        </Dialog>
      </div>
    )
  }
}

LabeledFamilyForm.propTypes = {
  idEdit: PropTypes.number,
  open: PropTypes.bool.isRequired,
  editMode: PropTypes.bool.isRequired,
  handleRefresh: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleFeedback: PropTypes.func.isRequired,
  profileAdminOrMasterData: PropTypes.func.isRequired,
}

export default LabeledFamilyForm
